export const sleep = (time: number) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const phoneRegex =
  /^(?:(0))(?:(70|80|81|90|91|80|92|93|94|95|96|97|98|99)\d{8})$/;
